// @flow

import * as React from 'react';

/**
 * Returns whichever argument in args has most recently changed, giving preference to earlier arguments
 * @param args expected to be the same length every time this is called, and length > 0
 */
const useLastChangedValue: <T>(...args: Array<T>) => T = <T>(...args: Array<T>) => {
  const prevValues = React.useRef(args);
  const lastChanged = React.useRef(args[0]);
  let retSet = false;
  for (let i = 0; i < args.length; i++) {
    if (prevValues.current[i] !== args[i]) {
      if (!retSet) {
        lastChanged.current = args[i];
        retSet = true;
      }
      prevValues.current[i] = args[i];
    }
  }

  return lastChanged.current;
};

export default useLastChangedValue;
